function showPrice() {
  let t = $(
    ".t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price"
  ).text();
  $(
    ".t4s-product__info-container .t4s-product__price-review .t4s-product-price ins"
  ).length > 0 &&
    (t = $(
      ".t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price ins"
    ).text()),
    $(".main-product-title-box .only-current-price").text(t);
}
$("body").on("click", ".product-variant-title-box", function () {
  console.log("2222"), $(this).toggleClass("hide-box");
}),
  $(document).ready(function () {
    $("[data-collage-toggle]").on("click", function () {
      let t = $(this).closest("[data-collage-item]");
      t.hasClass("open") ||
        $("[data-collage-item]")
          .removeClass("open")
          .find(".collage-content")
          .slideUp(200),
        t.toggleClass("open"),
        t.find(".collage-content").slideToggle(200);
   
          if($(this).data("type").indexOf("spec")!=-1){
          $(".t4s-category-item[data-categories='specs']").click();
          }

      
    });
  });
let showMediaStatus = !1;
function filterMediaShow(t) {
  let o = 0;
  t || showMediaStatus
    ? (console.log("quanbushifang"),
      $(".media_layout-custom_layout .t4s-product__media-item").removeClass("showMoreHide"))
    : $(".media_layout-custom_layout .t4s-product__media-item").each(function () {
        !$(this).hasClass("is--media-hide") &&
          ( ++o > 4 && $(this).addClass("showMoreHide"));
      });
}
$(document).ready(function () {
  filterMediaShow(!1);
}),
  $(document).ready(function () {
    767 >= $(window).width() &&
      ($(".t4s-footer-wrap").append($(".t4s-socials-block")),
      $(".t4s-socials-block").css("margin-top", "24px"));
  }),
  $(window).on("scroll", function () {
    $(".scroll-text-bg-image-box").each(function () {
      var t = $(window).scrollTop(),
        o = $(this).offset().top,
        e = $(this).outerHeight(),
        i = o - e;
      if (t + $(window).height() > o && t < o + e) {
        var s = -((t - i) * 0.12);
        767 > $(window).width() && (s = -((t - i) * 0.04)),
          $(this).css("background-position", "center " + s + "px");
      }
    });
  });

function initMiniCartSwiper() {
  if ($(window).width() < 1400) return;
  var miniCartSwiper = new Swiper(
    ".mini-cart-t4s-complimentary-container .swiper",
    {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      autoHeight: true,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next-{{section.id}}",
        prevEl: ".swiper-button-prev-{{section.id}}",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1401: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1919: {
          slidesPerView: "auto",
          spaceBetween: 30,
        },
      },
    }
  );
}

$(window).on("load", function () {
  var initToolbarFiltersCount = 0;
  var initToolbarFiltersTimer = setInterval(function () {
    initToolbarFiltersCount++;
    if (!$(".j-filter-btn").length) return;
    if (
      !$("#j-filter-wrapper #FacetFiltersForm .j-facet-item").length &&
      initToolbarFiltersCount < 20
    )
      return;

    function setToolbarFiltersVisible($button, visible) {
      var $facetItems = $("#j-filter-wrapper #FacetFiltersForm .j-facet-item");
      $facetItems.toggleClass("t4s-d-none", !visible);
      $button.toggleClass("is--active-btn", !visible);
      $button.find(".j--f-all").css("display", visible ? "none" : "inline");
      $button.find(".j--f-hide").css("display", visible ? "inline" : "none");
    }

    $(".j-filter-btn").each(function () {
      setToolbarFiltersVisible($(this), true);
    });

    $("body")
      .off("click", ".j-filter-btn")
      .on("click", ".j-filter-btn", function (event) {
        event.preventDefault();
        setToolbarFiltersVisible($(this), $(this).hasClass("is--active-btn"));
      });
    clearInterval(initToolbarFiltersTimer);
  }, 150);
});

(function () {
  if (window.nexProductVariantDropdownReady) return;
  window.nexProductVariantDropdownReady = true;

  function closeVariantDropdowns(exceptWrapper) {
    document
      .querySelectorAll(
        ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false.is--opened"
      )
      .forEach(function (wrapper) {
        if (wrapper !== exceptWrapper) wrapper.classList.remove("is--opened");
      });

    document
      .querySelectorAll(".t4s-swatch__list [data-dropdown-open].is--clicked")
      .forEach(function (button) {
        var wrapper = document.getElementById(button.getAttribute("data-id"));
        if (!exceptWrapper || wrapper !== exceptWrapper)
          button.classList.remove("is--clicked");
      });
  }

  document.addEventListener(
    "click",
    function (event) {
      var item = event.target.closest(
        ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false [data-dropdown-off]"
      );
      if (item) {
        setTimeout(function () {
          closeVariantDropdowns();
        }, 0);
        return;
      }

      var button = event.target.closest(
        ".t4s-swatch__list [data-dropdown-open]"
      );
      if (button) {
        var wrapper = document.getElementById(button.getAttribute("data-id"));
        if (!wrapper || !wrapper.classList.contains("is-style-mb--false"))
          return;

        event.preventDefault();
        event.stopPropagation();

        var shouldOpen = !wrapper.classList.contains("is--opened");
        closeVariantDropdowns(wrapper);
        button.classList.toggle("is--clicked", shouldOpen);
        wrapper.classList.toggle("is--opened", shouldOpen);

        var overlay = document.querySelector(".t4s-close-overlay");
        if (overlay) overlay.classList.remove("is--visible", "is--pindop");
        return;
      }

      if (
        !event.target.closest(
          ".t4s-swatch__list .t4s-dropdown__wrapper.is-style-mb--false"
        )
      ) {
        closeVariantDropdowns();
      }
    },
    true
  );
})();
